module.exports = __webpack_public_path__ + "static/img/tery_empty.7763529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tery_empty.png
// module id = TKRm
// module chunks = 1